<template>
  <div>
    <div style="line-height:20px;" v-if="showActualLocation">
      {{locationFullName}} <br>
      <small>{{ $t('Actual') }} - {{ locationCode }}</small>
    </div>
    <div v-else>
      {{locationFullName}}
    </div>
  </div>
</template>

<script>
import LocationTypeEnum from "../LocationTypeEnum.js";

export default {
  name: 'LocationCellRenderer',
  data() {
    return {
      locationId: null,
      locationCode: null,
      locationType: null,
      roundNumber: null,
      locations: []
    }
  },
  methods: {
    locationWithRound(locationCode) {
      if (this.roundNumber === null) {
        return locationCode;
      }
      else {
        return locationCode + "-" + this.roundNumber;
      }
    }
  },
  computed : {
    locationFullName() {
      if (this.locationId !== null && this.locations.length > 0) {
        const location = this.locations.find(l => l.locationId === this.locationId);
        if (location) {
          const typeDef = LocationTypeEnum.getSuffix(location.type);
          return this.locationWithRound(location.code) + "-" + typeDef;
        }
      }
      if (this.locationType === null) {
        return this.locationWithRound(this.locationCode)
      }
      else {
        const typeDef = LocationTypeEnum.getSuffix(this.locationType);
        return this.locationWithRound(this.locationCode) + "-" + typeDef;
      }
    },
    showActualLocation() {
      if (this.useActualLocation !== true)
        return false;

      if (this.locationId !== null && this.locationId !== undefined && this.locations.length > 0) {
        const location = this.locations.find(l => l.locationId === this.locationId);
        if (location) {
          return location.code !== this.locationCode;
        }
      }
      return true;
    }
  },
  created() {
    this.locations = this.params.value.locations;
    this.locationId = this.params.value.locationId;
    this.locationCode = this.params.value.locationCode;
    this.locationType = this.params.value.locationType;
    this.roundNumber = this.params.value.roundNumber === undefined ? null : this.params.value.roundNumber;
    this.useActualLocation = this.params.value.useActualLocation;
  }
}
</script>
